import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  state: {
    score: [],
    //score array, contains note objects as follows
    //[{
        // start: 3840, 1小節を3840単位と定義
        // length: 960, 1拍は960単位になる
        // onoff: true, 音符ならtrue, 休符ならfalse
        // dotted: false, 付点
        // tie: false, trueならこの音は鳴らさない, 前との間に描かれる
    //},]
    tempo: 120,
    beats: 4,
  },
  getters: {
    lastNote: function(state){
      if (state.score.length === 0) {
        return null;
      } else {
        return state.score[state.score.length-1];
      }
    },
    boxNum: function(state, getters){
      if (state.score.length === 0){
        return 1;
      } else {
        let length = getters.lastNote.start + getters.lastNote.length;
        return Math.ceil(length/3840);
      }
    },
    lastNoteEnds: function (state, getters) {
      if (state.score.length === 0) {
        return 0;
      } else {
        const lastNote = getters.lastNote;
        const position = lastNote.start + lastNote.length * (1 + (0.5 * lastNote.dotted));
        return position % (960*state.beats);
      }
    }
  },
  mutations: {
    addnote(state, payload){
      const add = function(state, payload){
        let start;
        if (state.score.length === 0){
          start = 0;
        } else {
          let last = state.score[state.score.length-1];
          start = last.start + last.length * (1 + (0.5 * last.dotted));
        }
        let content = payload.note;
        content.start = start;
        
        //休符の時にタイはつけないように
        content.tie = content.tie && content.onoff;

        //一番初めの音符にタイはつけないように
        if (content.start === 0 && content.tie) {
          return
        }

        //小節を跨ぐか跨がないか判断する
        const isCross = (content.start % 3840 + content.length * (1 + (0.5 * content.dotted)) > 3840);
        if (!isCross) {
          //音符の長さが小節を跨がないとき
          state.score.push(content);
        } else {
          //音符の長さが小節を跨ぐとき
          let length = content.length * (1 + (0.5 * content.dotted));
          const innerLength = 3840 - content.start % 3840;
          const outerLength = length - innerLength;

          //lengthを埋める音符を選択してpushする
          const choiceNotes = function(length, isInner){
            let isFirstNote = isInner;
            for (let i = 1; i <= 4; i++) {
              let l = 3840 / (2**i);
              // console.log(l);
              // console.log(length);
              if (length === 0) {
                break;
              }
              if (length >= l) {
                add(state, {note:{length:l, onoff:content.onoff, dotted:false, tie:!isFirstNote}});
                isFirstNote = false;
                length -= l;
                continue
              }
            }

          }

          choiceNotes(innerLength, true);
          choiceNotes(outerLength, false);

        }
        
      };
      add(state, payload);
    },
    backspace(state){
      state.score.pop();
    },
    tempoChange(state, payload){
      state.tempo = payload.tempo;
    }
  },
  actions: {
  },
  modules: {
  }
})
